
(function () {
    "use strict";

    // @ngInject
    function SelfOnboardingManagerCtor($q, APIService, Routes, ModelFactory) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
    }

    Services.SelfOnboardingManager = Class(Services.BaseModelManager, {
        constructor: SelfOnboardingManagerCtor,

        setStepComplete: function setStepComplete(user, step, data) {
            var url = this.Routes.v2_set_self_onboarding_step_complete_path(user._id, step);

            return this.apiUpdate(url, data, user, true);
        },

        getCurrStep: function getCurrStep(user) {
            var url = this.Routes.v2_get_self_onboarding_step_path(user._id);

            return this.apiFetch(url, null, user, true);
        },

        getAtwsData: function getAtwsData(user) {
            var url = this.Routes.v2_get_atws_data_path(user._id);

            return this.apiFetch(url, null, user, true);
        },

        createOnboardingInvoiceTemplate: function createOnboardingInvoiceTemplate() {
            var url = this.Routes.v2_create_onboarding_invoice_template_path();
            return this.apiCreate(url);
        },

        createOnboardingProposalTemplate: function createOnboardingProposalTemplate() {
            var url = this.Routes.v2_create_onboarding_proposal_template_path();
            return this.apiCreate(url);
        },

        createOnboardingProjectAndFile: function createOnboardingProjectAndFile(user, company, fileType) {
            var data = {
                file_type: fileType
            };
            var url = this.Routes.v2_create_onboarding_project_and_file_path();
            return this.apiCreate(url, data);
        },

        completeSetupGuideStep: function completeSetupGuideStep(user, stepName, versionName) {
            var data = {
                step_name: stepName,
                version_name: versionName
            };
            var url = this.Routes.v2_user_complete_setup_guide_step_path(user._id, stepName);
            return this.apiCreate(url, data, user, true);
        },

        mwebToDesktopEmail: function mwebToDesktopEmail() {
            var url = this.Routes.v2_mweb_to_desktop_email_path();
            return this.apiCreate(url);
            return this.apiCreate(url, data, user, true);
        },

        getOnboardingSequence: function getOnboardingSequence(user) {
            var url = this.Routes.v2_onboarding_sequence_path(user._id);
            return this.apiFetch(url);
        },

        completeOnboardingStep: function completeOnboardingStep(user, step) {
            var data = {};
            var url = this.Routes.v2_complete_onboarding_step_path(user._id, step.key);
            return this.apiCreate(url, data);
        },

        updateOnboardingData: function updateOnboardingData(user, data) {
            var url = this.Routes.v2_update_onboarding_data_path(user._id);
            return this.apiUpdate(url, data, user, true);
        }

    });
}());
